module.exports = __webpack_public_path__ + "static/img/524.6fc53c8.png";